module.exports = __webpack_public_path__ + "media/icon_transaction/hedgehog_2-59f92e5c.png";